import { Breadcrumb, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

import PageWrapper from "@/components/ui/PageWrapper";
import useBreadcrumbs from "@/hooks/useBreadcrumbs";

function OptionsIndex() {
  const { t } = useTranslation("options");
  const { crumbs } = useBreadcrumbs();

  return (
    <PageWrapper>
      <div className="mx-xl my-lg min-h-screen">
        <div className="mb-sm">
          <Breadcrumb crumbs={crumbs} />
        </div>
        <Typography step="3" as="h1" weight="bold" className="mb-sm">
          {t("options:title")}
        </Typography>
        <Outlet />
      </div>
    </PageWrapper>
  );
}

export default OptionsIndex;
